import React, { useEffect } from 'react';
import { Field } from 'formik';
import { SimpleWizardPageProps } from '../../../../common/components/simple-wizard/simple-wizard';
import { FormLayout, HeadingLayout, HeadingOne } from '../../../../common';
import { AddressInput } from '../../../../common/components/address-input/address-input';
import { useApplication } from 'src/hooks/useApplication';
import './modal-step-one.scss';

export type ModalStepOneProps = {
  wizardProps: SimpleWizardPageProps;
  isEditing: boolean;
  automationIdSuffix?: string;
  brokerLogin?: boolean;
};

export function ModalStepOne(props: ModalStepOneProps) {
  const { orderTealiumService } = useApplication();
  useEffect(() => {
    orderTealiumService?.onAddressDeliveryAction();
  }, []);

  return (
    <article className="ModalStepOne">
      <section className="heading-section">
        <HeadingLayout
          renderMainHeading={() => (
            <HeadingOne>{`${props.isEditing ? 'Edit' : 'Add a new'}`} delivery address</HeadingOne>
          )}
        />
      </section>

      <section className="address-fields">
        <FormLayout>
          <Field
            name="address"
            component={AddressInput}
            titleLowerCase="delivery address"
            brokerLogin={props.brokerLogin}
            isLightMode={true}
            automationid={`${props.automationIdSuffix}_Step_One`}
          />
        </FormLayout>
      </section>
    </article>
  );
}
